import { useEffect, useState } from "react";
import "../../../styles/referral.css";
import { referral_BASE_URL } from "../../../services/baseURL";
import inviteIcon from "../../../images/referral.png";
import cashbackIcon from "../../../images/cash-back.png";
import bonusIcon from "../../../images/bonus.png";
import ShimmerLoader from "../../utilComponents/shimmer";
import Ximg from "../../../images/X.png";
import { FaCopy } from "react-icons/fa";
import { useProfile, useMyReferrals } from "../../../services/hooks/getApi";
import {
  FacebookIcon,
  WhatsappIcon,
  EmailIcon,
  TelegramIcon,
  LinkedinIcon,
  PinterestIcon,
  RedditIcon,
} from "react-share";

const itemsPerPage = 3;

const Referral = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [copiedField, setCopiedField] = useState("");
  const [showModal, setShowModal] = useState(false); // For Modal
  const [referrals, setReferrals] = useState([]);

  const { data: profile, isLoading: isLoadingProfile } = useProfile();
  const {
    data: myReferrals,
    isLoading: isLoadingReferrals,
    error,
  } = useMyReferrals();
  console.log("myReferrals", myReferrals);

  useEffect(() => {
    if (myReferrals?.referredUsers) {
      setReferrals(myReferrals.referredUsers);
    }
  }, [myReferrals]);

  const totalPages = Math.ceil(referrals.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedUsers = referrals.slice(startIndex, startIndex + itemsPerPage);
  console.log("paginatedUsers", paginatedUsers);

  const handlePageChange = (direction) => {
    if (direction === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(""), 1500);
  };

  // Share referral URL ==============================
  const shareUrl = `${referral_BASE_URL}/register/${profile?.ReferralID}`;

  return (
    <div className="referral-container">
      {/* Header Section */}
      <div className="referral-header">
        <h2>Refer a Friend and Earn Rewards</h2>
        <button className="invite-btn" onClick={() => setShowModal(true)}>
          Invite Friends
        </button>
      </div>

      {/* How It Works */}
      <div className="referral-steps">
        <div className="step">
          <img src={inviteIcon} alt="Invite" height={50} width={50} />
          <p>
            <b>
              Invite your friend with your unique referral code "
              {isLoadingProfile ? (
                <span>Loading...</span>
              ) : (
                <span>{profile?.ReferralID}</span>
              )}
              "
            </b>
            <FaCopy
              onClick={() => handleCopy(profile?.ReferralID, "ReferralID")}
              style={{ color: "#b59f5b", marginLeft: 6 }}
            />
            {copiedField === "ReferralID" && (
              <span style={{ marginLeft: 6, color: "green" }}>Copied!</span>
            )}
          </p>
        </div>
        <div className="step">
          <img src={cashbackIcon} alt="Cashback" height={50} width={50} />
          <p>
            <b>Earn 1% cashback when they make their first Deposit</b>
          </p>
        </div>
        <div className="step">
          <img src={bonusIcon} alt="Bonus" height={50} width={50} />
          <p>
            <b>Bonus: Earn Rewards when they complete 4 weekly deposits</b>
          </p>
        </div>
      </div>

      {/* Referred Friends */}
      {/* Referred Friends */}
      <div className="referral-list-section">
        <h3>Referred Friends</h3>

        {isLoadingReferrals ? (
          <ShimmerLoader width="100%" height="80px" />
        ) : referrals.length === 0 ? (
          <p style={{ textAlign: "center", color: "gray" }}>
            You haven’t referred any friends yet!
          </p>
        ) : (
          <>
            <ul className="referral-list">
              {paginatedUsers.map((user, index) => (
                <li key={index}>
                  <div className="user-info">
                    <span className="avatar">
                      {user.fullName?.charAt(0) || "U"}
                    </span>
                    <div>
                      <strong>{user.fullName || "Unnamed User"}</strong>
                      <br />
                      <small>{user.phone || "No phone"}</small>

                      {/* Badges Section */}
                      <div className="referral-badges" style={{ marginTop: 8 }}>
                        {/* Has Deposited Badge */}
                        {user.hasDeposited ? (
                          <span className="badge badge-success">Deposited</span>
                        ) : (
                          <span className="badge badge-danger">
                            Not Deposited
                          </span>
                        )}

                        {/* Reward Amount Badge */}
                        {user.rewardApproved && user.rewardAmount > 0 && (
                          <span
                            className="badge badge-warning"
                            style={{ marginLeft: 6 }}>
                            {`💸 ₹${user.rewardAmount}/- Earned`}
                          </span>
                        )}

                        {/* Reward Approved Gift Icon */}
                        {user.rewardApproved && (
                          <span
                            className="badge badge-primary"
                            style={{ marginLeft: 6 }}>
                            🎁 Reward Approved
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            {/* Pagination */}
            <div className="pagination">
              <button
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}>
                Prev
              </button>
              <span>
                {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}>
                Next
              </button>
            </div>
          </>
        )}
      </div>

      {/* referral modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Share Referral Link via</h3>
            <div className="share-buttons">
              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  shareUrl
                )}`}
                target="_blank"
                rel="noopener noreferrer">
                <WhatsappIcon size={48} round />
              </a>

              <a
                href={`https://t.me/share/url?url=${encodeURIComponent(
                  shareUrl
                )}&text=Join Richesse and get monthly profits & benefits!`}
                target="_blank"
                rel="noopener noreferrer">
                <TelegramIcon size={48} round />
              </a>

              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                  shareUrl
                )}`}
                target="_blank"
                rel="noopener noreferrer">
                <LinkedinIcon size={48} round />
              </a>

              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  shareUrl
                )}`}
                target="_blank"
                rel="noopener noreferrer">
                <FacebookIcon size={48} round />
              </a>

              <a
                href={`https://reddit.com/submit?url=${encodeURIComponent(
                  shareUrl
                )}&title=Check this out!`}
                target="_blank"
                rel="noopener noreferrer">
                <RedditIcon size={48} round />
              </a>

              <a
                href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
                  shareUrl
                )}&media=&description=Join Richesse and get monthly profits & benefits!`}
                target="_blank"
                rel="noopener noreferrer">
                <PinterestIcon size={48} round />
              </a>

              <a
                href={`mailto:?subject=Join now!&body=Here’s something cool, Join Richesse and get monthly profits & benefits! : ${encodeURIComponent(
                  shareUrl
                )}`}
                target="_blank"
                rel="noopener noreferrer">
                <EmailIcon size={48} round />
              </a>

              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  shareUrl
                )}&text=Join Richesse and get monthly profits & benefits!`}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-share-btn">
                <img src={Ximg} alt="X" width={46} height={46} />
              </a>
            </div>

            <div className="share-link-container">
              <span className="share-url">{shareUrl}</span>
              <button
                className="copy-button"
                onClick={() => handleCopy(shareUrl, "shareUrl")}>
                {copiedField === "shareUrl" ? "Copied!" : "Copy"}
              </button>
            </div>

            <button
              className="modal-close-btn"
              onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Referral;
